import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { API_URL } from '../../../../lib/const';
import Axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { Documents } from '../../../components';
import { handleDocumentUpload } from '../../../services/upload_service';
import { get } from 'lodash';
import { Spinner } from '../../../elements';
import { TTransferApplicationStepPageProps } from '../types';

const TransferApplicationDocumentFormPage = ({ history, match, application, setApplication, requestedDocuments, loadingDocuments }: TTransferApplicationStepPageProps) => {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false)
  const token = match.params.token;

  const handleUploadDocument = async (event: InputEvent, requestDocumentId: number) => {
    const file = get(event, "target.files.0");

    try {
      const response = await handleDocumentUpload(file, requestDocumentId);
      const { key } = response;

      setApplication((v) => {
        return {
          ...v,
          documents: [
            ...v.documents,
            {
              key,
              name: file.name,
              url: `${API_URL}/uploads/${key}`,
              document_type: requestDocumentId,
              approved: null,
            }
          ]
        }
      })
    } catch (error) {
      toast.error("Ocorreu um erro ao enviar arquivo. Tente novamente.");
    }
  };

  const handleRemoveDocument = async (key: string) => {
    setApplication((v) => {
      if (v) {
        return {
          ...v,
          documents: v.documents.filter(d => d.key !== key),
        }
      }

      return v
    })
  };

  const handleCreateApplicationDocuments = useCallback(async () => {
    setLoading(true);
    const payload = { documents: application ? application.documents : [] }

    try {
      await Axios.post(`${API_URL}/transfers/applications/${token}/documents/bulk`, payload);

      setApplication((value) => ({ ...value, documentation_step_status: 'Preenchido' }))

      history.push(`/transferencias/aplicacao/${token}/resumo`);

    } catch (error) {
      const response = (error as AxiosError).response;

      if (response && response.status === 400) {
        setErrors(response.data);
        toast.error(response.data.non_field_errors || 'Ocorreu um erro ao enviar seus documentos.')

      } else {
        toast.error('Ocorreu um erro desconhecido enviar seus documentos.')

      }

    } finally {
      setLoading(false);

    }
  }, [application])

  return (
    <>
      {/* O spinner segue a busca dos tipos de documento, não a lista: uma lista vazia
          (processo sem documentos ou requisição que falhou) travava a tela carregando. */}
      <Spinner active={loading || !!loadingDocuments}>
        <div className="documents-base row">
          {requestedDocuments.length === 0 && !loadingDocuments && (
            <p className="text-muted">
              Nenhum documento foi solicitado neste processo. Entre em contato com a Secretaria.
            </p>
          )}
          {requestedDocuments.map(dt => (
            <Documents
              key={dt.id}
              label={dt.name}
              validations={dt.validations}
              is_required
              error={errors ? errors[`documents${dt.id}`] : undefined}
              onUpload={(event: InputEvent) => handleUploadDocument(event, dt.id)}
              onRemove={(key: string) => handleRemoveDocument(key)}
              documents={application ? application.documents.filter(d => d.document_type === dt.id) : []}
            />
          ))}
        </div>
      </Spinner>
      <div className="text-right mt-3">
        <div className="col-md-4 p-0 offset-md-8 col-sm-12">
          <div className="btn-actions">
            <button
              className="btn btn-black mr-2"
              onClick={() => history.push(`/transferencias/aplicacao/${token}/pessoais`)}
            >
              Voltar
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleCreateApplicationDocuments()}
            >
              {loading ? "Carregando..." : "Próximo"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferApplicationDocumentFormPage;
